import { Injectable } from '@angular/core';
import * as rx from 'rxjs';
import {
  FinopsError,
  FinopsEvent,
  FinopsMessage,
  FinopsOverlay,
  FinopsResult,
  isFinopsError,
  isFinopsEvent,
  isFinopsOverlay,
  isFinopsResult,
} from './finops-messaging.types';

@Injectable()
export class FinopsMessagingService {
  private finopsEventsSubject$ = new rx.Subject<FinopsEvent>();
  private finopsResultsSubject$ = new rx.Subject<FinopsResult>();
  private finopsOverlaysSubject$ = new rx.Subject<FinopsOverlay>();
  private finopsErrorsSubject$ = new rx.Subject<FinopsError>();

  private finopsEvents$ = this.finopsEventsSubject$.asObservable();
  private finopsResults$ = this.finopsResultsSubject$.asObservable();
  private finopsOverlays$ = this.finopsOverlaysSubject$.asObservable();
  private finopsErrors$ = this.finopsErrorsSubject$.asObservable();

  private finopsMessages$ = rx.merge(
    this.finopsEvents$,
    this.finopsResults$,
    this.finopsOverlays$,
    this.finopsErrors$,
  );

  getErrorStream() {
    return this.finopsErrors$;
  }

  pushError(finopsError: FinopsError) {
    this.finopsErrorsSubject$.next(finopsError);
  }

  getEventStream() {
    return this.finopsEvents$;
  }

  pushEvent(finopsEvent: FinopsEvent) {
    this.finopsEventsSubject$.next(finopsEvent);
  }

  getMessageStream() {
    return this.finopsMessages$;
  }

  pushMessage(finopsMessage: FinopsMessage) {
    if (isFinopsError(finopsMessage)) {
      this.pushError(finopsMessage);
    } else if (isFinopsEvent(finopsMessage)) {
      this.pushEvent(finopsMessage);
    } else if (isFinopsOverlay(finopsMessage)) {
      this.pushOverlay(finopsMessage);
    } else if (isFinopsResult(finopsMessage)) {
      this.pushResult(finopsMessage);
    }
    // fail silently
  }

  getOverlayStream() {
    return this.finopsOverlays$;
  }

  pushOverlay(finopsOverlay: FinopsOverlay) {
    this.finopsOverlaysSubject$.next(finopsOverlay);
  }

  getResultStream() {
    return this.finopsResults$;
  }

  pushResult(finopsResult: FinopsResult) {
    this.finopsResultsSubject$.next(finopsResult);
  }
}
